<template>
  <div class="container">
      <section class="section">
      <div class="columns">
          <div class="column">
              <div class="">
                    <p class="is-size-1 has-text-centered has-text-white">Spare Part: {{ part.number }}</p>
                    <section class="section has-background-dvolightgrey rounded">
                        <p class="has-text-left is-size-5 has-text-white"> Spare Part Number: {{ part.number}}</p>
                        <p class="has-text-left is-size-5 has-text-white"> Spare part Description: {{ part.description}}</p>
                    </section>
              </div>
          </div>
      </div>
      </section>
    <section class="section">
      <div class="columns">
            <div class="column">
                <p class="is-size-3 has-text-centered has-text-white">Products</p>
                <b-table
                    :data="part.products"
                    :bordered="true"
                    :striped="true"
                    :loading="isLoading"
                    :mobile-cards="false"
                    :narrowed="true"
                    :paginated="true"
                    :per-page="10">
                    <b-table-column field="code" label="Product Code" v-slot="props">
                        {{ props.row.code }}
                    </b-table-column>
                    <b-table-column field="code" label="Description" v-slot="props">
                        {{ props.row.description }}
                    </b-table-column>                    
                    <template #empty>
                        <div class="has-text-centered">No records</div>
                    </template>
                </b-table>             
            </div>
              <div class="column">
                <p class="is-size-3 has-text-centered has-text-white">Codes</p>
                <b-table
                    :data="part.codes"
                    :bordered="true"
                    :striped="true"
                    :loading="isLoading"
                    :narrowed="true"
                    :mobile-cards="false"
                    :paginated="true"
                    :per-page="10">
                    <b-table-column field="code" label="Code" v-slot="props">
                        {{ props.row.code}}
                    </b-table-column>
                    <b-table-column field="description" label="Description" v-slot="props">
                        {{ props.row.description}}
                    </b-table-column>                    
                    <template #empty>
                        <div class="has-text-centered">No records</div>
                    </template>
                </b-table>                  
            </div>              
          </div>
    </section>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
import { getPartDetail } from '../../graphql/queries';

export default {
    data(){
        return {
            part: {},
            isLoading: false
        }
    },
    methods: {
    async getParts() {  
        const Parts = await API.graphql({
        query: getPartDetail,
            variables: { 
                input: 
                    {
                        id: this.$route.params.id
                    }
            }
        });
        this.part = Parts.data.getPartDetail;
        console.log(this.part)
        },
    },
    async created(){
        const Parts = await API.graphql({
            query: getPartDetail,
                variables: { 
                    input: 
                    {
                    id: this.$route.params.id
                    }
                }
        });
        this.part = Parts.data.getPartDetail
    }
}
</script>

<style scoped>
.rounded{
    border-radius: 5px;
}
</style>